import ReportImpactDestination from './reportImpactDestination'
export default ReportImpactDestination
